const initState = {
  fjs: [
    {id: '1', title: "diet matador #1", content: "lots of stuff"},
    {id: '2', title: "diet matador #2", content: "lots of stuff#2"},
    {id: '3', title: "diet matador #3", content: "lots of stuff#3"}
  ]
};

export const fjsReducer = (state = initState, action) => {
  switch (action.type) {
    case 'CREATE_FJS':
      console.log('created fjs', action.fjStory)
      return state;
    case 'CREATE_FJS_ERROR':
      console.log('created project error: ', action.err)
      return state;
    default: 
      return state;
  }
};
